import { PropsWithChildren } from 'react';

export function Container({ children }: PropsWithChildren) {
  return (
    <section className="container flex w-full max-w-[1536px] flex-col gap-4 px-4 sm:px-6 lg:px-8 last:pb-4">
      {children}
    </section>
  );
}
